/** Keep enough horizontal room for catalog controls after the shared section rail. */
export const CR_ROW_LABEL = "cr-row-label";
export const CR_ROW_LABEL_WITH_MARKERS = "cr-row-label--with-markers";

/** FieldHistoryList's own classes (theme/caseReview.css); the popover that hosts it owns .cr-popover. */
export const CR_HISTORY_CLASS = "cr-history";
export const CR_HISTORY_STATUS_CLASS = "cr-history-status";
export const CR_HISTORY_ERROR_CLASS = "cr-history-error";
export const CR_HISTORY_EMPTY_CLASS = "cr-history-empty";
export const CR_HISTORY_EMPTY_TITLE_CLASS = "cr-history-empty-title";
export const CR_HISTORY_LIST_CLASS = "cr-history-list";
export const CR_HISTORY_ENTRY_CLASS = "cr-history-entry";
export const CR_HISTORY_ENTRY_WHEN_CLASS = "cr-history-entry-when";
export const CR_HISTORY_ENTRY_CHANGE_CLASS = "cr-history-entry-change";
export const CR_HISTORY_ENTRY_FROM_CLASS = "cr-history-entry-from";
export const CR_HISTORY_ENTRY_ARROW_CLASS = "cr-history-entry-arrow";
export const CR_HISTORY_ENTRY_TO_CLASS = "cr-history-entry-to";
export const CR_HISTORY_ENTRY_TO_PII_CLASS = "cr-history-entry-to cr-history-entry-to--pii";
export const CR_HISTORY_ENTRY_WHO_CLASS = "cr-history-entry-who";
export const CR_HISTORY_ENTRY_SOURCE_CLASS = "cr-history-entry-source";
export const CR_HISTORY_ENTRY_REASON_CLASS = "cr-history-entry-reason";
export const CR_DEADLINE_HISTORY_PANEL_CLASS = "cr-portal cr-deadline-history";
export const CR_DEADLINE_HISTORY_TITLE_CLASS = "cr-deadline-history-title";
export const CR_DEADLINE_HISTORY_DETAILS_CLASS = "cr-deadline-history-details";
/** The tag of a deadline result that counts a missing listedness verdict as Unlisted. */
export const CR_ASSUMED_TAG_CLASS = "cr-assumed-tag";

/** QueriesPanel / CloseQueryDrawer's own classes (theme/caseReview.css). */
export const CR_QUERIES_PANEL_CLASS = "cr-queries-panel";
export const CR_QUERIES_HEADER_CLASS = "cr-queries-header";
export const CR_QUERIES_TITLE_CLASS = "cr-queries-title";
export const CR_QUERIES_STATUS_CLASS = "cr-queries-status";
export const CR_QUERIES_ERROR_CLASS = "cr-queries-error";
export const CR_QUERIES_EMPTY_CLASS = "cr-queries-empty";
export const CR_QUERIES_TABS_CLASS = "cr-queries-tabs";
export const CR_QUERIES_TAB_CLASS = "cr-queries-tab";
export const CR_QUERIES_TAB_COUNT_CLASS = "cr-queries-tab-count";
export const CR_QUERIES_TABLE_CLASS = "cr-queries-table";
export const CR_QUERIES_ROW_CLASS = "cr-queries-row";
export const CR_QUERIES_CODE_CLASS = "cr-queries-code";
export const CR_QUERIES_BADGE_CLASS = "cr-queries-badge";
export const CR_QUERIES_BADGE_DOT_CLASS = "cr-queries-badge-dot";
export const CR_QUERIES_DUE_OVERDUE_CLASS = "cr-queries-due-overdue";
export const CR_QUERIES_PENDING_CLOSURE_CLASS = "cr-queries-pending-closure";
export const CR_QUERIES_ACTIONS_CLASS = "cr-queries-actions";
export const CR_QUERIES_CREATE_FORM_CLASS = "cr-queries-create-form";
export const CR_QUERIES_DRAWER_CLASS = "cr-queries-drawer";
export const CR_QUERIES_DRAWER_FIELD_CLASS = "cr-queries-drawer-field";
export const CR_QUERIES_DRAWER_ACTIONS_CLASS = "cr-queries-drawer-actions";
export const CR_QUERIES_SUBTITLE_CLASS = "cr-queries-subtitle";
export const CR_QUERIES_QUESTION_CLASS = "cr-queries-question";
export const CR_QUERIES_QUESTION_HEAD_CLASS = "cr-queries-question-head";
export const CR_QUERIES_QUESTION_CHIP_CLASS = "cr-queries-question-chip";
export const CR_QUERIES_QUESTION_EVIDENCE_CLASS = "cr-queries-question-evidence";
export const CR_QUERIES_QUESTIONS_TABLE_CLASS = "cr-queries-questions";
export const CR_QUERIES_FIELD_CLASS = "cr-queries-field";
export const CR_QUERIES_NOTICE_CLASS = "cr-queries-notice";
export const CR_QUERIES_WARNING_CLASS = "cr-queries-warning";
export const CR_QUERIES_LETTER_CLASS = "cr-queries-letter";
export const CR_QUERIES_LETTER_FRAME_CLASS = "cr-queries-letter-frame";
export const CR_QUERIES_ATTEMPTS_CLASS = "cr-queries-attempts";
export const CR_QUERIES_TIMELINE_CLASS = "cr-queries-timeline";
export const CR_QUERIES_TIMELINE_ITEM_CLASS = "cr-queries-timeline-item";
export const CR_QUERIES_TIMELINE_DOT_CLASS = "cr-queries-timeline-dot";
export const CR_QUERIES_TIMELINE_DETAIL_CLASS = "cr-queries-timeline-detail";
export const CR_QUERIES_LINK_CLASS = "cr-queries-link";

/** CaseLinksPanel's own classes (theme/caseReview.css). */
export const CR_LINKS_PANEL_CLASS = "cr-links-panel";
export const CR_LINKS_HEADER_CLASS = "cr-links-header";
export const CR_LINKS_TITLE_CLASS = "cr-links-title";
export const CR_LINKS_DESCRIPTION_CLASS = "cr-links-description";
export const CR_LINKS_STATUS_CLASS = "cr-links-status";
export const CR_LINKS_ERROR_CLASS = "cr-links-error";
export const CR_LINKS_EMPTY_CLASS = "cr-links-empty";
export const CR_LINKS_LIST_CLASS = "cr-links-list";
export const CR_LINKS_ITEM_CLASS = "cr-links-item";
export const CR_LINKS_ITEM_HEADER_CLASS = "cr-links-item-header";
export const CR_LINKS_CASE_CLASS = "cr-links-case";
export const CR_LINKS_TYPE_CLASS = "cr-links-type";
export const CR_LINKS_JUSTIFICATION_CLASS = "cr-links-justification";
export const CR_LINKS_AUDIT_CLASS = "cr-links-audit";
